import { clientApi } from "@/utils/api";
import { TApiRes } from "@/types/api";

type TResendLoginVerifyCodeRequest = {
  email: string;
  pendingAuthToken: string;
};

type TResendLoginVerifyCodeResponse = {
  message: string;
};

export const resendLoginVerifyCodeApi = async (payload: TResendLoginVerifyCodeRequest): Promise<TResendLoginVerifyCodeResponse> => {
  const {
    data: { data },
  } = await clientApi.post<TApiRes<TResendLoginVerifyCodeResponse>>("/resend-login-verify-code", payload);
  return data;
};
